import { BACKEND_BASE_URL } from "./backendBaseUrl";
export const NOTIFICATION_BASE_URL =
  BACKEND_BASE_URL + "/notification";
